import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-stone-50 border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        {/* Top row */}
        <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-12 mb-16">
          {/* Brand */}
          <div className="flex-shrink-0 max-w-xs">
            <Link to="/" className="flex items-center gap-3 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/1286ceb3-1c4c-499f-bb53-de2e12d300c4.png"
                  alt="KURTA logo"
                  className="w-9 h-9 object-contain"
                />
              </div>
              <span className="text-lg font-bold tracking-widest text-stone-900">KURTA</span>
            </Link>
            <p className="text-sm text-stone-500 leading-relaxed">
              Studio de design graphique et visuel à Bordeaux. Solutions simples, modernes et efficaces.
            </p>
          </div>

          {/* Navigation columns */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 lg:gap-16">
            {/* Navigation */}
            <div>
              <h4 className="text-xs font-semibold tracking-widest text-stone-400 uppercase mb-4">
                <a href="#navigation">Navigation</a>
              </h4>
              <ul className="flex flex-col gap-3">
                {[
                  { label: 'Accueil', to: '/' },
                  { label: 'À propos', to: '/a-propos' },
                  { label: 'Contact', to: '/contact' },
                ].map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-stone-600 hover:text-stone-900 transition-colors duration-150 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Légal */}
            <div>
              <h4 className="text-xs font-semibold tracking-widest text-stone-400 uppercase mb-4">
                <a href="#legal">Légal</a>
              </h4>
              <ul className="flex flex-col gap-3">
                {[
                  { label: 'Conditions générales', to: '/conditions-generales' },
                  { label: 'Confidentialité', to: '/politique-de-confidentialite' },
                ].map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-stone-600 hover:text-stone-900 transition-colors duration-150 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-xs font-semibold tracking-widest text-stone-400 uppercase mb-4">
                <a href="#contact-info">Contact</a>
              </h4>
              <ul className="flex flex-col gap-3">
                <li className="text-sm text-stone-600">
                  2 Rue Pelleport<br />33800 Bordeaux, France
                </li>
                <li>
                  <a
                    href="tel:+33751313477"
                    className="text-sm text-stone-600 hover:text-stone-900 transition-colors duration-150"
                  >
                    +33 7 51 31 34 77
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:daw1dkurta@inbox.eu"
                    className="text-sm text-stone-600 hover:text-stone-900 transition-colors duration-150"
                  >
                    daw1dkurta@inbox.eu
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-stone-200 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-stone-400">
            &copy; {year} KURTA – Dawid Kurta. SIRET&nbsp;: 102&nbsp;042&nbsp;504&nbsp;00013
          </p>
          <p className="text-xs text-stone-400">
            74.10Z – Activités spécialisées de design
          </p>
        </div>
      </div>
    </footer>
  );
}